import initials from 'initials'

export const getPageSize = (dpi = 96) => ({
  width: 8.5 * dpi,
  height: 11 * dpi
})

export const isUndefinedOrNull = (v) => typeof v === 'undefined' || v === null

export const isNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return true
  else return false
}

export const hexToRGB = (hex, opacity) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  const r = parseInt(result[1], 16)
  const g = parseInt(result[2], 16)
  const b = parseInt(result[3], 16)

  return `rgba(${r}, ${g}, ${b}, ${opacity || 1})`
}

export const formatDateToString = (date) => {
  let day = date.getDate()
  let month = date.getMonth() + 1
  const year = date.getFullYear()

  day = day < 10 ? '0' + day : day
  month = month < 10 ? '0' + month : month

  return `${day}.${month}.${year}`
}

export const getNumberFromString = (str, to = 4) => {
  // create a hash from the string
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  // use the hash to get a number between 0 and to (not included)
  return Math.abs(hash % to)
}

export const getInitials = (fullName, maxInitials = 2) => {
  return initials(fullName).slice(0, maxInitials).toUpperCase()
}

export const circleRadius = (size) => size / 2
